import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitleFromPath } from '../../constants/routes';

const LayoutContext = createContext({
    activeTab: '',
    setActiveTab: () => {},
});

export const LayoutProvider = ({ children }) => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('');

    // Update page title based on route changes
    useEffect(() => {
        const pageTitle = getPageTitleFromPath(location.pathname, location.search);
        setActiveTab(pageTitle);
        sessionStorage.setItem('activeTabLabel', pageTitle);
    }, [location.pathname, location.search]);

    // Also listen to custom events for manual title updates (e.g., from Backbone code)
    useEffect(() => {
        const handleActiveTabChange = (e) => {
            if (e.detail && e.detail.activeTabLabel !== undefined) {
                setActiveTab(e.detail.activeTabLabel);
            }
        };

        window.addEventListener('activeTabChanged', handleActiveTabChange);

        return () => {
            window.removeEventListener('activeTabChanged', handleActiveTabChange);
        };
    }, []);

    return <LayoutContext.Provider value={{ activeTab, setActiveTab }}>{children}</LayoutContext.Provider>;
};

export const useLayoutContext = () => useContext(LayoutContext);
